import AliceCarousel from "react-alice-carousel";

export default function CustomAliceCarousel({ images, autoPlayInterval, height = "40vh" }) {
    const handleDragStart = (e) => e.preventDefault();
    function setImages(arr) {
        const images = arr.map((item) => (
            <img
                key={item}
                component="img"
                alt="img"
                onDragStart={handleDragStart}
                role="presentation"
                src={item}
                style={{
                    width: "100%",
                    height: height,
                    objectFit: "cover",
                    objectPosition: "25% 25%",

                }}
            />
        ));
        return images;
    }

    return <AliceCarousel
        items={setImages(images)}

        autoPlay={(images.length > 1 ? true : false)}

        infinite
        autoPlayInterval={autoPlayInterval}
        disableDotsControls
        disableButtonsControls

    />
}